/**
 * Context for the undo snackbar system.
 * Provides a way to show undoable action notifications with countdown.
 */

import { createContext } from 'react';

export interface UndoState {
  /** Unique identifier for this undo action */
  id: number;
  /** Message to display (e.g., "Archived", "Deleted") */
  message: string;
  /** Callback to execute when user clicks Undo */
  undoCallback: () => void | Promise<void>;
  /** Timestamp when the snackbar should auto-dismiss */
  expiresAt: number;
}

export interface UndoSnackbarContextValue {
  /**
   * Show an undo snackbar with the given message and callback.
   * If a snackbar is already showing, it will be replaced.
   * @param message - The action message to display
   * @param undoCallback - Function to call when Undo is clicked
   */
  showUndo: (message: string, undoCallback: () => void | Promise<void>) => void;

  /**
   * Dismiss the current snackbar without executing the undo callback.
   */
  dismiss: () => void;
}

export const UndoSnackbarContext = createContext<UndoSnackbarContextValue | null>(null);
